import { Link } from "react-router-dom";
import { CheckCircle2, Phone, MessageCircle } from "lucide-react";
import { SEO } from "../components/SEO";
import { business } from "../content/site";
import { PagePhoto } from "../components/PagePhoto";
import { pagePhotos } from "../content/photos";
import { trackEvent } from "../lib/analytics";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

export default function Thanks() {
  const c = useCopy("thanks");
  const lp = useLp();
  return (
    <>
      <SEO title={c.seoT} description={c.seoD} path="/gracias/" />
      <section className="container-site section-gap" data-testid="thanks-page">
        <div className="max-w-2xl mx-auto text-center">
          <CheckCircle2 size={52} className="mx-auto text-precision" aria-hidden="true" />
          <h1 className="mt-6 text-3xl sm:text-4xl font-bold leading-tight">{c.h1}</h1>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{c.text}</p>
          <p className="mt-4 text-sm text-slate-600">{c.urgent}</p>
          <PagePhoto photo={pagePhotos["_gracias"]} className="mt-10" />
          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <a href={business.phoneHref} onClick={() => trackEvent("phone_click", { location: "gracias" })}
               data-testid="thanks-phone" className="btn-secondary">
              <Phone size={15} aria-hidden="true" /> {business.phoneDisplay}
            </a>
            <a href={business.whatsappUrl} target="_blank" rel="noopener noreferrer"
               onClick={() => trackEvent("whatsapp_click", { location: "gracias" })}
               data-testid="thanks-whatsapp" className="btn-secondary">
              <MessageCircle size={15} aria-hidden="true" /> WhatsApp
            </a>
          </div>
          <Link to={lp("/")} className="mt-10 inline-block link-underline text-sm font-bold" data-testid="thanks-home-link">
            {c.back}
          </Link>
        </div>
      </section>
    </>
  );
}
